import { IMessagingService } from "../services";
import { Container } from "./container";

abstract class Component extends Container {

    constructor(componentEl: HTMLElement, messagingService: IMessagingService) {
        super(componentEl, messagingService);
    }
};

export { Component }